import { isMobileViewHook } from "@/customHooks/isMobileViewHook";
import { isInStandaloneMode } from "@/utils";
import { NewsTicker } from "components/NewsTicker";
import ProfileDetailsComponent from "components/ProfileComponent";
import { roles } from "constant/constants";
import { useEffect, useState } from "react";
import { HiBell } from "react-icons/hi";
import { IoCaretBackOutline, IoRefreshOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Classes from "./AfterLoginHeader.module.css";

export const AfterLoginHeader = ({ header, drawerBtn }) => {
  const { unReadNotificationCount } = useSelector(
    (state) => state?.commonReducer
  );
  const { user } = useSelector((state) => state?.authReducer);
  const [isMobile, setIsMobile] = useState(false);
  const path = useLocation()?.pathname;
  const [slidesToShow, setSlidesToShow] = useState([]);

  const splitPath = path.split("/");
  const navigate = useNavigate();

  useEffect(() => {
    isMobileViewHook((e) => {
      setIsMobile(e);
    });
  }, []);

  useEffect(() => {
    const tempSlides = [];
    if (user?.testSession !== null && user?.role === roles.STUDENT) {
      const type = user?.testSession?.assessmentCycle
        ? "assessment"
        : "admission";
      const id = user?.testSession?.assessmentCycle
        ? user?.testSession?.assessmentCycle
        : user?.testSession?.quickAssessment;
      tempSlides.push({
        text: `Your test is in progress.`,
        path: `test-session/${type}/${id}/${user?.testSession?._id}`,
      });
    }
    setSlidesToShow(tempSlides);
  }, [user]);

  return (
    <div>
      <div className={Classes.navbarContainer}>
        {drawerBtn && drawerBtn}
        <div className={Classes.mainHeader}>
          {splitPath?.length > 2 && (
            <IoCaretBackOutline
              color="var(--secondary-color)"
              size={24}
              onClick={() => navigate(-1)}
              cursor={"pointer"}
            />
          )}
          <h1 className={Classes.heading}>{header}</h1>
        </div>
        {isInStandaloneMode() && (
          <div
            className={Classes.notification_header}
            onClick={() => window.location.reload()}
            title="Refresh"
          >
            <IoRefreshOutline color="var(--secondary-color)" />
          </div>
        )}
        <div
          className={Classes.notification_header}
          onClick={() => navigate("/notifications")}
        >
          {unReadNotificationCount > 0 && (
            <p>
              {unReadNotificationCount > 9 ? "9+" : unReadNotificationCount}
            </p>
          )}
          <HiBell color="var(--secondary-color)" />
        </div>
        <div className={Classes.separator}></div>

        <ProfileDetailsComponent user={user} isMobile={isMobile} />
      </div>
      {slidesToShow?.length > 0 && (
        <div className={Classes.subscriptionEnds}>
          <NewsTicker slides={slidesToShow} />
        </div>
      )}
    </div>
  );
};
